import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/core';
import "swiper/css";
import { PlaceholdersLoaderGif, ImgWithPlaceholder, VideoWithPlaceholder } from '../../ui'
import { ChevronLeft, ChevronRight, Close, SettingsOutlined, StarBorderPurple500Outlined, Star } from '@mui/icons-material';

export function MediaCarousel({ media, initialSlide, handleClose, handleSettings, onlyReadAlbum, handleToggleFavorite }) {
    const [actualIndex, setActualIndex] = React.useState(initialSlide);
    const swiperRef = React.useRef(null);
    const [touchStart, setTouchStart] = React.useState({ x: 0, y: 0 });
    const [isSwiping, setIsSwiping] = React.useState(false);

    const _handleSettings = () => {
        handleSettings(actualIndex);
    }

    const handleTouchStart = (e) => {
        // Solo per tocchi singoli (non zoom a 2 dita)
        if (e.touches.length === 1) {
            setTouchStart({
                x: e.touches[0].clientX,
                y: e.touches[0].clientY
            });
            setIsSwiping(false);
        }
    };

    const handleTouchMove = (e) => {
        if (e.touches.length === 1 && touchStart.x !== 0) {
            const currentX = e.touches[0].clientX;
            const diffX = Math.abs(currentX - touchStart.x);
            const diffY = Math.abs(e.touches[0].clientY - touchStart.y);
            
            // Solo se il movimento orizzontale è maggiore di quello verticale
            if (diffX > diffY && diffX > 50) {
                setIsSwiping(true);
            }
        }
    };

    const handleTouchEnd = (e) => {
        if (e.changedTouches.length === 1 && isSwiping && touchStart.x !== 0) {
            const endX = e.changedTouches[0].clientX;
            const diffX = touchStart.x - endX;
            
            // Minimo 80px di movimento per triggerare lo swipe
            if (Math.abs(diffX) > 80) {
                if (diffX > 0) {
                    // Swipe left -> next
                    swiperRef.current?.swiper?.slideNext();
                } else {
                    // Swipe right -> prev  
                    swiperRef.current?.swiper?.slidePrev();
                }
            }
        }
        
        // Reset
        setTouchStart({ x: 0, y: 0 });
        setIsSwiping(false);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowRight') {
                swiperRef.current.swiper.slideNext();
            }
            if (e.key === 'ArrowLeft') {
                swiperRef.current.swiper.slidePrev();
            }
            if (e.key === 'Escape') {
                handleClose();
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        }
    }, [handleClose, swiperRef])

    useEffect(() => {
        const url = new URL(window.location.href);
        url.searchParams.set('gallery', actualIndex);
        window.history.replaceState({}, '', url);
    }, [actualIndex]);

    return (
        <div 
            className="position-fixed top-0 start-0 w-100 h-100 bg-tertiary p-2 pt-5 pb-5 d-flex align-items-center justify-content-center z-1000"
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
        >
            <Swiper
                centeredSlides={true}
                pagination={{
                    clickable: true,
                    dynamicBullets: true,
                }}
                navigation={{ nextEl: '.arrow-right', prevEl: '.arrow-left' }}
                modules={[Pagination, Navigation]}
                className="mySwiper h-100"
                initialSlide={initialSlide}
                onSlideChangeTransitionEnd={(swiper) => setActualIndex(swiper.activeIndex)}
                ref={swiperRef}
                // disable move carousel with drag and drop, only arrow to make zoom work
                allowTouchMove={false}
            >

                {media.map((item, index) => {
                    const isActualIndexOrNear = index === actualIndex || index === actualIndex - 1 || index === actualIndex + 1;
                    return <SwiperSlide key={index} className='overflow-hidden'>
                        <div className='d-flex justify-content-center align-items-center h-100'>
                            {
                                item.type.includes('image') && isActualIndexOrNear &&
                                <ImgWithPlaceholder
                                    src={item.url}
                                    className="d-block img-fluid pe-none mw-100 mh-100" alt={'image'}
                                    unselectable="on"
                                    type={item.type}
                                    placeholder={PlaceholdersLoaderGif.loader_1200_1200}
                                    enableZoom={true}
                                    itemId={`id_${item.id}`}
                                />}
                            {
                                item.type.includes('video') && actualIndex === index &&
                                <VideoWithPlaceholder
                                    src={item.url}
                                    className="h-100 w-auto d-block img-fluid"
                                    alt={'video'}
                                    autoPlay={true}
                                    controls={true}
                                    isCurrent={index === actualIndex}
                                    isCarousel={true}
                                />}
                        </div>
                    </SwiperSlide>
                })}
            </Swiper>
            <button type="button" className="btn rounded-5 text-dark fs-6 btn-primary position-absolute bottom-0 start-0 mb-4 ms-2 z-1 arrow-left">
                <ChevronLeft />
            </button>
            <button type="button" className="btn rounded-5 text-dark fs-6 btn-primary position-absolute bottom-0 end-0 mb-4 me-2 z-1 arrow-right">
                <ChevronRight />
            </button>
            <Close onClick={handleClose} className="position-absolute top-0 start-0 m-2 text-primary p-2 cursor-pointer z-1" sx={{ fontSize: 45 }} />
            {!onlyReadAlbum &&
                <SettingsOutlined
                    onClick={_handleSettings}
                    className="position-absolute top-0 start-0 m-2 ms-5 text-primary p-2 cursor-pointer z-1" sx={{ fontSize: 45 }} />
            }
            {media[actualIndex].favorite ? 
                <Star
                    onClick={handleToggleFavorite}
                    className="position-absolute top-0 end-0 m-2 text-primary p-2 cursor-pointer z-1" sx={{ fontSize: 45 }} />
                :  <StarBorderPurple500Outlined
                    onClick={handleToggleFavorite}
                    className="position-absolute top-0 end-0 m-2 text-primary p-2 cursor-pointer z-1" sx={{ fontSize: 45 }} />
            }
            
        </div>
    );
}